module.exports = __webpack_public_path__ + "static/result-network.16617710.png";